import config from "../config"

export function docToItem (envRes) {
    let environment = envRes.environment || {}

    return environment                   
}
